<template>
  <div class="admin-dashboard">
    <!-- Header -->
    <header class="header">
      <div class="header-left">
        <button class="sidebar-toggle" @click="toggleSidebar">
          <i class="fas fa-bars"></i>
        </button>
        <!-- <h1>Admin Dashboard</h1> -->
      </div>
      <div class="header-right">
        <!-- Notifications -->
        <div class="notifications" @click="toggleNotifications">
          <i class="fas fa-bell"></i>
          <span class="notification-count">3</span>
          <div v-if="showNotifications" class="notification-popup">
            <div class="notification-item">New order received</div>
            <div class="notification-item">Product out of stock</div>
            <div class="notification-item">System update available</div>
          </div>
        </div>

        <!-- Profile Dropdown -->
        <div class="profile" @click="toggleProfileDropdown">
          <img src="@/assets/img/default/admin-avatar.jpg" alt="Admin Avatar" />
          <span>Admin</span>
          <i class="fas fa-caret-down"></i>
          <div v-if="showProfileDropdown" class="profile-dropdown">
            <div class="dropdown-item" @click="navigateToProfile">Profile</div>
            <div class="dropdown-item" @click="navigateToSettings">
              Settings
            </div>
            <div class="dropdown-item" @click="handleLogout">Exite</div>
          </div>
        </div>
      </div>
    </header>

    <!-- Sidebar -->
    <aside
      class="sidebar"
      :class="{ collapsed: isSidebarCollapsed, open: isSidebarOpen }"
    >
      <div class="sidebar-menu">
        <router-link to="/">EKU MARKET</router-link>
        <ul>
          <li>
            <router-link to="/dashboard" class="menu-item">
              <i class="fas fa-home"></i>
              <span>Overview</span>
            </router-link>
          </li>
          <li>
            <div class="menu-item" @click="toggleSubMenu('orders')">
              <i class="fas fa-shopping-cart"></i>
              <span>Orders</span>
              <i class="fas fa-angle-down"></i>
            </div>
            <ul v-if="isSubMenuOpen('orders')" class="sub-menu">
              <li>
                <router-link to="/dashboard/orders">All Orders</router-link>
              </li>
              <li>
                <router-link to="/dashboard/orders/pending"
                  >Pending Orders</router-link
                >
              </li>
              <li>
                <router-link to="/dashboard/orders/completed"
                  >Completed Orders</router-link
                >
              </li>
            </ul>
          </li>

          <li>
            <div class="menu-item" @click="toggleSubMenu('products')">
              <i class="fas fa-box"></i>
              <span>Products</span>
              <i class="fas fa-angle-down"></i>
            </div>
            <ul v-if="isSubMenuOpen('products')" class="sub-menu">
              <li>
                <router-link to="/dashboard/products">All Products</router-link>
              </li>
              <li>
                <router-link to="/dashboard/my-products">My Products</router-link>
              </li>
              <li>
                <router-link to="/dashboard/products/add"
                  >Add Product</router-link
                >
              </li>
            </ul>
          </li>

          <li>
            <div class="menu-item" @click="toggleSubMenu('Users')">
              <i class="fas fa-box"></i>
              <span>Users</span>
              <i class="fas fa-angle-down"></i>
            </div>
            <ul v-if="isSubMenuOpen('Users')" class="sub-menu">
              <li>
                <router-link to="/dashboard/agents">All Agents</router-link>
              </li>
              <li>
                <router-link to="/dashboard/staffs">EKU stafffs</router-link>
              </li>
            </ul>
          </li>

          <li>
            <router-link to="/dashboard/customers" class="menu-item">
              <i class="fas fa-users"></i>
              <span>Customers</span>
            </router-link>
          </li>
          <li>
            <router-link to="/dashboard/analytics" class="menu-item">
              <i class="fas fa-chart-line"></i>
              <span>Analytics</span>
            </router-link>
          </li>
          
          <li>
            <div class="menu-item" @click="toggleSubMenu('Settings')">
              <i class="fas fa-box"></i>
              <span>Settings</span>
              <i class="fas fa-angle-down"></i>
            </div>
            <ul v-if="isSubMenuOpen('Settings')" class="sub-menu">
              <li>
                <router-link to="/dashboard/categoriies"
                  >Product Categories</router-link
                >
              </li>
              <li>
                <router-link to="/dashboard/product-brands"
                  >Product Brands</router-link
                >
              </li>
              <li>
                <router-link to="/dashboard/payment-methods"
                  >Payment Methods</router-link
                >
              </li>
              <li>
                <router-link to="/dashboard/payment-statuses"
                  >Payment Statuses</router-link
                >
              </li>
              <li>
                <router-link to="/dashboard/order-statuses"
                  >Order Statusees</router-link
                >
              </li>
            </ul>
          </li>


        </ul>
      </div>
    </aside>

    <!-- Overlay for Small Screens -->
    <div
      v-if="isSidebarOpen && isSmallScreen"
      class="sidebar-overlay"
      @click="closeSidebar"
    ></div>

    <!-- Main Content -->
    <main class="main-content p-4">
      <router-view></router-view>
    </main>

    <FloatingActionButton />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/Stores/authStore";
import FloatingActionButton from '@/components/FloatingMenu.vue'

const router = useRouter();
const authStore = useAuthStore();

// Sidebar State
const isSidebarCollapsed = ref(false);
const isSidebarOpen = ref(false);

// Submenu State
const openSubMenu = ref(null);

// Profile Dropdown State
const showProfileDropdown = ref(false);

// Notifications Popup State
const showNotifications = ref(false);

// Small Screen State
const isSmallScreen = ref(false);

// Check screen size on mount and resize
const checkScreenSize = () => {
  isSmallScreen.value = window.innerWidth <= 768;
};

onMounted(() => {
  checkScreenSize();
  window.addEventListener("resize", checkScreenSize);
});

onUnmounted(() => {
  window.removeEventListener("resize", checkScreenSize);
});

// Toggle Sidebar
const toggleSidebar = () => {
  if (isSmallScreen.value) {
    isSidebarOpen.value = !isSidebarOpen.value;
  } else {
    isSidebarCollapsed.value = !isSidebarCollapsed.value;
  }
};

// Close Sidebar on Small Screens
const closeSidebar = () => {
  if (isSmallScreen.value) {
    isSidebarOpen.value = false;
  }
};

// Toggle Submenu
const toggleSubMenu = (menu) => {
  openSubMenu.value = openSubMenu.value === menu ? null : menu;
};

// Check if Submenu is Open
const isSubMenuOpen = (menu) => {
  return openSubMenu.value === menu;
};

// Toggle Profile Dropdown
const toggleProfileDropdown = () => {
  showProfileDropdown.value = !showProfileDropdown.value;
  showNotifications.value = false;
};

// Toggle Notifications Popup
const toggleNotifications = () => {
  showNotifications.value = !showNotifications.value;
  showProfileDropdown.value = false;
};

// Navigate to Profile
const navigateToProfile = () => {
  router.push("/dashboard/profile");
};

// Navigate to Settings
const navigateToSettings = () => {
  router.push("/dashboard/settings");
};

// Logout
const handleLogout = () => {
  authStore.ResetAuthData();
  router.push("/");
  console.log("User logged out!");
};
</script>

<style scoped>
/* General Styles */
.admin-dashboard {
  display: flex;
  min-height: 100vh;
  background-color: #f8f9fa;
}

/* Header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sidebar-toggle {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Notifications */
.notifications {
  position: relative;
  cursor: pointer;
}

.notification-count {
  position: absolute;
  top: -5px;
  right: -10px;
  background-color: #ff4d4d;
  color: #fff;
  font-size: 0.8rem;
  padding: 2px 6px;
  border-radius: 50%;
}

.notification-popup {
  position: absolute;
  top: 30px;
  right: 0;
  background-color: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 200px;
  padding: 10px;
  z-index: 1000;
}

.notification-item {
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}

@media (max-width: 768px) {
  .notification-popup {
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    /* width: 90%; */
  }
}

/* Profile */
.profile {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  position: relative;
}

.profile img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.profile-dropdown {
  position: absolute;
  top: 40px;
  right: 0;
  background-color: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 1000;
}

.dropdown-item {
  padding: 10px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

/* be carefull here */
.main-content {
  flex: 1;
  margin-left: 250px;
  padding: 100px 20px 20px;
  transition: margin-left 0.3s ease;
  /* max-width: calc(100% - 250px); */
  box-sizing: border-box;
}
.sidebar.collapsed + .main-content {
  margin-left: 60px;
  max-width: calc(100% - 60px);
}
/* up to here */

/* Sidebar */
.sidebar {
  width: 250px;
  background-color: #2c3e50;
  color: #fff;
  padding-top: 80px;
  transition: transform 0.3s ease, width 0.3s ease;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
}

.sidebar.collapsed {
  width: 60px;
  overflow: hidden;
}

/* Sidebar Visibility on Large Screens */
@media (min-width: 769px) {
  .sidebar {
    transform: translateX(0) !important;
    width: 250px;
  }

  .sidebar.collapsed {
    transform: translateX(-100%) !important;
    width: 0 !important;
  }

  .main-content {
    margin-left: 250px;
    width: calc(100% - 250px);
  }

  .sidebar.collapsed + .main-content {
    margin-left: 0;
    width: 100%;
  }
}

/* Sidebar Visibility on Small Screens */
@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
    width: 250px;
    padding: 4px;
    top: 5rem;
  }

  .sidebar.open {
    transform: translateX(0);
    width: 250px;
  }

  /* Adjust main content width on small screens */
  .main-content {
    margin-left: 0;
    margin-right: 0;
    width: 100%; /* Allow content to take up full width */
    padding: 20px; /* Add some padding for better spacing */
    box-sizing: border-box; /* Make sure padding doesn’t affect the width */
  }

  .sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 998;
    display: none;
  }

  .sidebar.open + .sidebar-overlay {
    display: block; /* Show overlay when sidebar is open */
  }

  /* When the sidebar is collapsed, adjust content margin */
  .sidebar.collapsed + .main-content {
    margin-left: 0; /* Remove left margin when sidebar is collapsed */
    width: 100%; /* Ensure the content takes full width */
  }
}

/* Sidebar Menu */
.sidebar-menu ul {
  list-style: none;
  padding: 0;
}

.sidebar-menu .menu-item {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}

.sidebar-menu .menu-item:hover {
  background-color: #34495e;
}

.sidebar-menu .menu-item i {
  margin-right: 10px;
}

.sidebar-menu .sub-menu {
  padding-left: 40px;
}

.sidebar-menu .sub-menu li {
  padding: 10px 0;
}

.sidebar-menu .sub-menu a {
  color: #fff;
  text-decoration: none;
}

.sidebar-menu .sub-menu a:hover {
  color: #cc0000;
}

/* Overlay for Small Screens */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  display: none;
}

/* Main Content */
/* .main-content {
  flex: 1;
  margin-left: 250px;
  padding: 100px 20px 20px;
  transition: margin-left 0.3s ease;
} */

/* .sidebar.collapsed + .main-content {
  margin-left: 60px;
} */
</style>
